import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/stacyharrison/Desktop/code/stasquatch.github.io/src/templates/post.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Quick look`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Required?`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sort of?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Common attributes`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`typically none`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Common aria`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none allowed`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Summary`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`head`}</inlineCode>{` tag is where metadata about the page will go, such as
page title, stylesheet links, and SEO information. Outside of your typical
HTML webpage, the `}<inlineCode parentName="p">{`head`}</inlineCode>{` tag should not be used for iframe, srcdoc, or
email content. This blog entry will only be covering `}<inlineCode parentName="p">{`head`}</inlineCode>{` as it's used
in typical web development.`}</p>
    <p>{`Typical children of the `}<inlineCode parentName="p">{`head`}</inlineCode>{` tag include:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`title`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`base`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`link`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`style`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`meta`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`script`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`noscript`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`template`}</inlineCode></li>
    </ul>
    <p>{`While it's not strictly required, it's good practice to include it. If
you omit the tag, browsers will usually insert it for you. Because
browsers can have different behavior, you `}<em parentName="p">{`may`}</em>{` get unexpected side effects
relying on this implementation.`}</p>
    <p><inlineCode parentName="p">{`head`}</inlineCode>{` must be the first child of the `}<inlineCode parentName="p">{`html`}</inlineCode>{` tag (`}<inlineCode parentName="p">{`body`}</inlineCode>{` being the second child).`}</p>
    <h3>{`Attributes`}</h3>
    <p>{`In previous specs, the `}<inlineCode parentName="p">{`profile`}</inlineCode>{` attribute could be used. This has been removed
in HTML5.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes"
      }}>{`Global attributes`}</a></p>
    <h3>{`Usage`}</h3>
    <pre><code parentName="pre" {...{}}>{`<!DOCTYPE html>
<html lang="en">
  <head>
    …
  </head>
  <body>
    …
  </body>
</html>
`}</code></pre>
    <p><em parentName="p">{`Note: `}<inlineCode parentName="em">{`…`}</inlineCode>{` denotes miscellaneous HTML, removed for brevity.`}</em></p>
    <h3>{`Links`}</h3>
    <p><a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head"
      }}>{`MDN: The head tag`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      